<script>
    export let result
    export let reset
    export let name

    import { fade } from "svelte/transition"

    const links = [
        "https://www.youtube.com/embed/uWqnz8-LkfY",
        "https://www.youtube.com/embed/Rq7pU0mk_ms",
        "https://www.youtube.com/embed/dJns4JQAKGI",
    ]

    const share = () => {
        const url = "https://loveequation.spaceth.co"
        FB.ui({
            method: 'share',
            href: `${url}/share/${name}.html`
        }, function(response){});
    
    }
</script>

<svelte:head>
    <script>
        window.fbAsyncInit = function() {
          FB.init({
            appId            : '554026952618182',
            autoLogAppEvents : true,
            xfbml            : true,
            version          : 'v12.0'
          });
        };
      </script>
      <script async defer crossorigin="anonymous" src="https://connect.facebook.net/en_US/sdk.js"></script>      
</svelte:head>

<style>
    h3 {
        font-size: 1.5em;
        font-weight: 300;
        color: #fff;
        align-content: center;
 	}

    .result {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        margin-top: 5em;
        width: 40%;
    }

    .result-button {
        display: flex;
        flex-direction: row;
        margin-top: 1em;
        margin-bottom: 1em;
    }

    .description {
        margin: 1em 0;
        text-align: center;
    }

    .equation {
            filter: invert(84%) sepia(0%) saturate(66%) hue-rotate(317deg) brightness(100%) contrast(108%);
            margin: 2em 1em;
            width: 100%;
            max-height: 5em;
    }

    .videos-wrapper {
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        width: 80vw;
        margin-bottom: 1em;
    }

    .video-wrapper {
        position: relative;
        width: 32%;
        height: 0;
        padding-bottom: calc(0.32 * 56.25%);
        margin-bottom: 3em;
    }

    .spaceth-wrapper {
        position: relative;
        width: 100%;
        height: 0;
        padding-bottom: 56.25%;
        margin-bottom: 2em;
    }

    iframe {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
    }

 	@-webkit-keyframes hue {
 		from {
 			filter: hue-rotate(0deg);
 			-webkit-filter: hue-rotate(0deg);
 		}
 		to {
 			filter: hue-rotate(-30deg);
 			-webkit-filter: hue-rotate(-30deg);
 		}
 	}

	@media (max-width: 640px) {
        h1 {
            font-size: 1.5em;
            margin-top: 0.2em;
            margin-bottom: 0.5em;
        }

        h3 {
            font-size: 1.2em;
            font-weight: 300;
            margin-bottom: 1em;
        }

		.result {
            margin-top: 5em;
            width: 70%;
        }

        .equation {
            margin: 0.5em;
        }

        .videos-wrapper {
            flex-direction: column;
        }

        .video-wrapper {
            width: 100%;
            padding-bottom: 56.25%;
            margin-bottom: 1em;
        }

	}
</style>

<div in:fade="{{ duration: 1000 }}" class="result">
    <h3>สมการความรักของคุณคือ</h3>
    <!-- <h1>{@html result.equation}</h1> -->
    <img src={`assets/equations/${name}.svg`} alt="" class="equation">
    <!-- <h3>{result.name}</h3> -->
    <div class="description"><span style="font-weight: bold">{result.name}:</span> {result.description}</div>
    <div class="result-button">
        <button on:click={share}>แชร์</button>
        <button on:click={reset}>กลับ</button>
    </div>
    <h3>ชมสมการความรักจาก EP. Album Galaxy of D Gerrard</h3>
    <div class="videos-wrapper">
    {#each links as link}
        <div class="video-wrapper">
            <iframe src={link}
                    title="YouTube video player" 
                    frameborder="0" 
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                    allowfullscreen>
            </iframe>
        </div>
    {/each}
    </div>
</div>